import { PALETTES, Palette } from "../../../../../constants/palettes";
import { getFooterParts } from "../../../../../util/get-footer-parts";
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Collapse from "../../../../common/collapse";
import { VerticalCaret } from "./vertical-caret";
import { AccordionWrapper, AccordionHeading, LinksWrapper } from "./styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Accordion = function Accordion(_ref) {
  var _ref$link = _ref.link,
    titleKey = _ref$link.title,
    links = _ref$link.links,
    palette = _ref.palette,
    renderLink = _ref.renderLink,
    _ref$accordionGroup = _ref.accordionGroup,
    toggle = _ref$accordionGroup.toggle,
    activeAccordion = _ref$accordionGroup.activeAccordion,
    t = _ref.t,
    onOpened = _ref.onOpened;
  var active = activeAccordion === titleKey;
  var title = t(titleKey);
  var _getFooterParts = getFooterParts(title),
    titleFirstPart = _getFooterParts.titleFirstPart,
    titleSecondPart = _getFooterParts.titleSecondPart;
  useEffect(function () {
    active && onOpened({
      title: title
    });
  }, [active, onOpened, title]);
  var handleClick = useCallback(function (event) {
    toggle(titleKey);
    event.stopPropagation();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [toggle]);
  var handleFocus = useCallback(function () {
    if (active) return;
    toggle(titleKey);
  }, [active, titleKey, toggle]);
  return /*#__PURE__*/_jsxs(AccordionWrapper, {
    active: active,
    onFocus: handleFocus,
    palette: palette,
    tabIndex: 0,
    children: [/*#__PURE__*/_jsxs(AccordionHeading, {
      active: active,
      "data-testid": "accordion-heading",
      onMouseDown: handleClick,
      children: [/*#__PURE__*/_jsx("span", {
        dangerouslySetInnerHTML: {
          __html: titleFirstPart
        }
      }), /*#__PURE__*/_jsxs("span", {
        style: {
          whiteSpace: 'nowrap'
        },
        children: [titleFirstPart && ' ', titleSecondPart, /*#__PURE__*/_jsx(VerticalCaret, {
          active: active
        })]
      })]
    }), /*#__PURE__*/_jsx(Collapse, {
      isOpened: active,
      children: /*#__PURE__*/_jsx(LinksWrapper, {
        active: active,
        children: links.map(renderLink)
      })
    })]
  });
};
Accordion.propTypes = {
  renderLink: PropTypes.func.isRequired,
  link: PropTypes.shape({
    title: PropTypes.string.isRequired,
    links: PropTypes.array.isRequired
  }).isRequired,
  palette: PropTypes.oneOf(PALETTES),
  accordionGroup: PropTypes.shape({
    toggle: PropTypes.func.isRequired,
    activeAccordion: PropTypes.string
  }),
  t: PropTypes.func.isRequired,
  onOpened: PropTypes.func
};
Accordion.defaultProps = {
  accordionGroup: {
    toggle: function toggle() {},
    activeAccordion: null
  },
  palette: Palette.Positive,
  onOpened: function onOpened() {}
};
Accordion.displayName = 'Accordion';